import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AlertService, Toast } from '../../Services/notifications/alert.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  toasts: Toast[] = [];

  constructor(private alertService: AlertService) {
    this.alertService.toasts$.subscribe(list => {
      this.toasts = list;
    });
  }

  dismiss(id: string) {
    this.alertService.remove(id);
  }

  iconForType(type?: Toast['type']) {
    switch (type) {
      case 'success': return 'check_circle';
      case 'error': return 'error';
      case 'warning': return 'warning';
      default: return 'info';
    }
  }
}
